import { StatusEnum } from "@ds/model/status-model";

import { InvitationStatusEnum } from "./model";

export const getInvitationPrintableStatus = (status: InvitationStatus) =>
  ({
    [InvitationStatusEnum.Pending]: StatusEnum.Pending,
    [InvitationStatusEnum.Expired]: StatusEnum.Cancelled,
  })[status];
